import styled from "styled-components";

export const BlockContainer = styled.div`
  background-color: white;

  padding: 20px;
`;
